<template>
  <bk-view class="kisHome">
    <!--      <bk-view class="bg-img">-->
    <!--      <img src="https://static.wixstatic.com/media/4f814e3e2f4d454c840d648287c5ee4c.jpg/v1/fill/w_571,h_1236,al_c,q_85,enc_avif,quality_auto/4f814e3e2f4d454c840d648287c5ee4c.jpg" alt="KIS Hair, Barber, Melbourne CBD, Hairdresser" width="320" height="440" style="width: 320px; height: 693px; object-fit: cover; object-position: 50% 50%;" fetchpriority="high">-->
    <!--      </bk-view>-->
    <bk-view class="view-appointment" ref="topRef">
      <bk-view class="bg-img">
        <img
          src="https://static.wixstatic.com/media/4f814e3e2f4d454c840d648287c5ee4c.jpg/v1/fill/w_571,h_1236,al_c,q_85,enc_avif,quality_auto/4f814e3e2f4d454c840d648287c5ee4c.jpg"
          alt="KIS Hair, Barber, Melbourne CBD, Hairdresser"
          style="width: 100%; height: 693px; object-fit: cover; object-position: 50% 50%;"
          fetchpriority="high">
      </bk-view>
      <bk-view class="view-tipWrap">
        <bk-view class="tip">MAKE AN APPOINTMENT WITH A KIS HAIRSTYLIST</bk-view>
        <bk-view class="book-btn black" @click="bookNow">Book Now!</bk-view>
      </bk-view>
    </bk-view>
    <bk-view class="view-about" ref="aboutRef">
      <bk-title>About Us</bk-title>
      <bk-view class="about-item">
        KIS Hair understands the emotional relationship that we have with our hair. This informs the KIS philosophy. We
        offer bespoke service that emphasizes precision and detail. You will enjoy a careful consultation, and a
        positive and relaxed experience.
      </bk-view>
      <bk-view class="about-item">Established on 2014, we currently have 2 premium shops located on Spencer Street and
        Bourke Street in Melbourne CBD. Over 40 professional hairstylists and team members proudly provided and served
        over thousand and hundreds clients. Book yourself in for an hair cut and colour with a member of our fabulous
        team. They are on the forefront of the latest techniques to ensure that you have that good hair month that you
        always dreamed about.
      </bk-view>
      <bk-view class="about-item">
        Make an appointment with KIS Hair today by download our shop own APP on Apple store or Google play store. Enjoy
        most playful APP with our joyful team and clients. You'll leave with a bounce in your step and in your hair!
      </bk-view>
      <bk-view class="book-btn view-book" @click="bookNow">Book Now!</bk-view>
    </bk-view>

    <bk-view class="view-gallery" ref="galleryRef">
      <bk-view class="gallery-title"> Gallery</bk-view>
      <bk-view class="gallery-row1 ">

        <bk-image :src="gallery[0]" @click="previewImg(0, 0)"/>
      </bk-view>
      <bk-view class="gallery-row2">
        <bk-view>
          <bk-image :src="gallery[1]" @click="previewImg(0, 1)"/>
        </bk-view>
        <bk-view>
          <bk-image :src="gallery[2]" @click="previewImg(0, 2)"/>
        </bk-view>
      </bk-view>
      <bk-view class="gallery-row3">
        <bk-image :src="gallery[3]" @click="previewImg(0, 3)"/>
      </bk-view>
      <bk-view class="gallery-row4">
        <bk-image :src="gallery[4]" @click="previewImg(0, 4)"/>
      </bk-view>
    </bk-view>

    <bk-view class="view-product" ref="productRef">
      <bk-view class="product-title">Products</bk-view>
      <bk-view class="logo-wrap">
        <bk-view class="logo-item" v-for="(item, index) in productsLogo" :key="index">
          <bk-view style="width: 110px;margin-bottom: 10px;" v-if="index===4">
            <!--?xml version="1.0" encoding="UTF-8"?-->
            <svg preserveAspectRatio="xMidYMid meet" data-bbox="0 0 459.9 267.96" viewBox="0 0 459.9 267.96"
                 xmlns="http://www.w3.org/2000/svg" data-type="color" role="presentation" aria-hidden="true"
                 aria-label="">
              <g>
                <path fill="#231f20"
                      d="m24.38 219.38-.01 20.95-17.97-.01.01-20.95-6.38-.01L0 267.1h6.38l.01-22.55 17.98.01-.02 22.55h6.37l.03-47.73z"
                      data-color="1"></path>
                <path
                  d="M77.1 230.93c-1.18-3.75-1.39-5.76-1.39-5.76h-.14s-.28 2.01-1.46 5.76l-5.7 18.11h14.22l-5.54-18.1Zm11.08 36.22-4.5-14.29H67.31l-4.65 14.27h-5.83l16.19-47.72h5.69l16.07 47.74h-6.59Z"
                  fill="#231f20" data-color="1"></path>
                <path fill="#231f20" d="M127.47 219.44v47.73h-6.38v-47.73z" data-color="1"></path>
                <path
                  d="M169.74 222.52c-2.36 0-4.16.34-5.41 1.03v19.98c.68.21 2.42.42 4.08.42 7.77 0 11.52-3.88 11.52-10.75 0-7.29-3.19-10.69-10.19-10.69m10.38 44.7-15.67-22.28h-.14l-.01 22.27h-6.31l.03-45.87c2.5-1.38 6.73-2.57 11.86-2.56 10.82 0 16.38 5.29 16.37 14.17 0 8.12-5.77 12.97-14.51 13.1v.14l15.59 21.03z"
                  fill="#231f20" data-color="1"></path>
                <path
                  d="M230.85 267.94c-11.45 0-17.89-11.04-17.89-24.57 0-13.26 6.39-24.57 17.92-24.56 4.23 0 7.21 1.11 9.3 2.65l-1.53 3.74c-1.46-.9-3.67-1.87-6.66-1.87-9.17 0-12.36 9.92-12.36 20.05s3.52 19.77 12.27 19.78c2.92 0 4.86-.76 6.66-1.86l1.67 4.02c-2.09 1.6-5.49 2.64-9.37 2.64"
                  fill="#231f20" data-color="1"></path>
                <path
                  d="M283.39 231.06c-1.18-3.75-1.38-5.76-1.38-5.76h-.14s-.28 2.01-1.46 5.76l-5.71 18.11h14.23l-5.54-18.1Zm11.08 36.22-4.5-14.29h-16.38l-4.65 14.27h-5.84l16.2-47.72h5.69l16.07 47.74z"
                  fill="#231f20" data-color="1"></path>
                <path
                  d="M339.04 222.62c-2.36 0-4.17.34-5.41 1.03v19.98c.68.21 2.42.42 4.08.42 7.77 0 11.52-3.88 11.53-10.75 0-7.29-3.19-10.69-10.2-10.69m10.38 44.7-15.67-22.28h-.14l-.01 22.27h-6.31l.03-45.87c2.5-1.38 6.73-2.57 11.86-2.56 10.82 0 16.38 5.29 16.37 14.17 0 8.12-5.77 12.97-14.51 13.1v.14l15.6 21.03z"
                  fill="#231f20" data-color="1"></path>
                <path fill="#231f20"
                      d="m384.22 219.6-.03 47.73 22.13.02v-4.31l-15.74-.01.01-18.24 14.15.01v-4.24h-14.15l.01-16.66 15.75.01v-4.3z"
                      data-color="1"></path>
                <path
                  d="m139.02 179.49.05-88.77c0-12.36-5.94-23.57-23.78-23.58-10.3 0-18.3 3.43-25.4 10.97l-.06 101.36H69.68l.06-89.7c0-13.72-9.13-22.88-26.98-22.89-10.07 0-15.56 1.36-22.19 4.1l-.07 108.45H.37L.44 62.5c11.22-5.49 23.12-8.69 42.79-8.67s30.42 5.74 37.75 14.9c8.47-8.92 21.06-14.86 38.22-14.85 29.51.02 40.03 19.25 40.02 36.41l-.05 89.23h-20.13Z"
                  fill="#231f20" data-color="1"></path>
                <path
                  d="M235.34 182.07c-30.89-.02-43.69-15.58-43.67-40.29l.05-85.56h20.13l-.05 86.26c0 14.41 7.76 25.4 24.69 25.41 9.61 0 16.48-1.59 22.2-5.02l.07-106.62h20.13l-.07 116.01c-9.16 5.25-23.58 9.82-43.48 9.81"
                  fill="#231f20" data-color="1"></path>
                <path fill="#231f20"
                      d="m317.13 0-.11 179.61 19.68.01.04-63.61h.46l47.09 63.64 22.88.01-51.68-65.7 46.72-57.62-21.05-.01-43.96 57.16h-.46L336.81.01z"
                      data-color="1"></path>
                <path
                  d="M445.61 181.84c-8.01 0-14.52-6.52-14.51-14.53 0-8.01 6.38-14.28 14.52-14.28 8.01 0 14.28 6.29 14.28 14.3 0 8.14-6.28 14.51-14.29 14.51m0-2.5c6.61 0 11.79-5.28 11.79-12.01 0-6.61-5.17-11.79-11.78-11.8-6.74 0-12.02 5.17-12.02 11.78 0 6.63 5.39 12.02 12.01 12.03"
                  fill="#231f20" data-color="1"></path>
                <path
                  d="M448.95 168.81c1.68-.6 2.79-2.26 2.79-4.07 0-3.52-2.69-4.77-5.76-4.77h-5.62v14.94h3.03v-5.15h2.98l2.62 5.15h3.37zm-3.67-1.42h-1.89v-4.93h2.08c2.2 0 3.03 1.01 3.03 2.48 0 1.63-1.24 2.45-3.22 2.45"
                  fill="#231f20" data-color="1"></path>
              </g>
            </svg>
          </bk-view>
          <bk-image v-else :src="item"/>
        </bk-view>
      </bk-view>
      <bk-view class="product1-wrap">
        <bk-view class="marquee">
          <bk-image v-for="(item, index) in products1" :src="item" :key="item" @click="()=>previewImg(1, index)"/>
        </bk-view>
      </bk-view>
      <bk-view class="product2-wrap">
        <bk-view class="marquee">
          <bk-image v-for="(item, index) in products2" :src="item" :key="item" @click="()=>previewImg(2, index)"/>
        </bk-view>
      </bk-view>
    </bk-view>

    <storeLocation @bookBtnClick="$emit('bookBtnClick')"/>
  </bk-view>
</template>

<script>
	import {gallery, productsLogo, products1, products2} from './dataSource';
	import BkView from '../../../../components/bk-base/bk-view/bk-view.vue';
	import BkTitle from '../../../../components/bk-base/bk-title/bk-title.vue';
	import StoreLocation from '../storeLocation/storeLocation.vue';
	import {showImagePreview} from 'vant';

	export default {
		name: 'kisHome',
		components: {StoreLocation, BkTitle, BkView},
		props: {
			anchors: String, // about  gallery product
		},
		data () {
			return {gallery, productsLogo, products1, products2};
		},
		computed: {},
		watch: {
			anchors: {
				handler (val) {
					setTimeout(() => {
						this.$nextTick(() => {
							const elRef = {
								about: 'aboutRef',
								gallery: 'galleryRef',
								product: 'productRef'
							}[this.anchors] || 'topRef';

							if (elRef === 'topRef') {
								window.scrollTo({
									top: 0,
									behavior: 'smooth'
								});
								return;
							}
							this.$refs[elRef].$el.scrollIntoView({
								behavior: 'smooth',
								block: 'start',
								inline: 'nearest'
							});
						});
					}, 300);
				},
				immediate: true
			}
		},
		methods: {
			previewImg (type = 0, index) {
				if (type === 0) {
					showImagePreview({
						images: [
							'https://static.wixstatic.com/media/7ceffa_c0faa93300bb403d9bc1f2bfdbf597d8~mv2.jpg/v1/fit/w_430,h_664,q_90,enc_avif,quality_auto/7ceffa_c0faa93300bb403d9bc1f2bfdbf597d8~mv2.jpg',
							'https://static.wixstatic.com/media/7ceffa_79e6d1c9864e4652b61c47beac893b57~mv2.jpg/v1/fit/w_430,h_664,q_90,enc_avif,quality_auto/7ceffa_79e6d1c9864e4652b61c47beac893b57~mv2.jpg',
							'https://static.wixstatic.com/media/7ceffa_c80fdfb1fb824d16af63297061c69a81~mv2.jpg/v1/fit/w_430,h_664,q_90,enc_avif,quality_auto/7ceffa_c80fdfb1fb824d16af63297061c69a81~mv2.jpg',
							'https://static.wixstatic.com/media/7ceffa_b05ab54b1192430a9bb6339d9018da98~mv2.jpg/v1/fit/w_430,h_664,q_90,enc_avif,quality_auto/7ceffa_b05ab54b1192430a9bb6339d9018da98~mv2.jpg',
							'https://static.wixstatic.com/media/7ceffa_75f84d4c268649d183bff444f96a658a~mv2.jpg/v1/fit/w_430,h_664,q_90,enc_avif,quality_auto/7ceffa_75f84d4c268649d183bff444f96a658a~mv2.jpg'
						],
						startPosition: index
					});
				}
				if (type === 1) {

					showImagePreview({
						images: [
							'https://static.wixstatic.com/media/7ceffa_1b2f47c0af8b4b37b23ec79d7b797c86~mv2_d_1261_1772_s_2.jpg/v1/fit/w_430,h_933,q_90,enc_avif,quality_auto/7ceffa_1b2f47c0af8b4b37b23ec79d7b797c86~mv2_d_1261_1772_s_2.jpg',
							'https://static.wixstatic.com/media/7ceffa_39d81acf5c2d4812b5095d51618b9cd2~mv2_d_1261_1772_s_2.jpg/v1/fit/w_430,h_933,q_90,enc_avif,quality_auto/7ceffa_39d81acf5c2d4812b5095d51618b9cd2~mv2_d_1261_1772_s_2.jpg',
							'https://static.wixstatic.com/media/7ceffa_44a3c679522e40ce96641b77b832dbec~mv2_d_1261_1772_s_2.jpg/v1/fit/w_430,h_933,q_90,enc_avif,quality_auto/7ceffa_44a3c679522e40ce96641b77b832dbec~mv2_d_1261_1772_s_2.jpg',
							'https://static.wixstatic.com/media/7ceffa_7f15af99c6f445e994cde86356238e5f~mv2_d_1261_1772_s_2.jpg/v1/fit/w_430,h_933,q_90,enc_avif,quality_auto/7ceffa_7f15af99c6f445e994cde86356238e5f~mv2_d_1261_1772_s_2.jpg',
							'https://static.wixstatic.com/media/7ceffa_66f68d7c00d948c9b87a597e4dff7a16~mv2_d_1261_1772_s_2.jpg/v1/fit/w_430,h_933,q_90,enc_avif,quality_auto/7ceffa_66f68d7c00d948c9b87a597e4dff7a16~mv2_d_1261_1772_s_2.jpg',
							'https://static.wixstatic.com/media/7ceffa_f6f6b6ae030a4de79afd36f8c8615157~mv2_d_1261_1772_s_2.jpg/v1/fit/w_430,h_933,q_90,enc_avif,quality_auto/7ceffa_f6f6b6ae030a4de79afd36f8c8615157~mv2_d_1261_1772_s_2.jpg'
						],
						startPosition: index
					});
				}

				if (type === 2) {

					showImagePreview({
						images: [
							'https://static.wixstatic.com/media/7ceffa_03fca84eb1574233977562d60cf4b7ba~mv2.png/v1/fit/w_430,h_664,q_90,enc_avif,quality_auto/7ceffa_03fca84eb1574233977562d60cf4b7ba~mv2.png',
							'https://static.wixstatic.com/media/7ceffa_b2af1100d668434084c6500587fedaa8~mv2.png/v1/fit/w_430,h_664,q_90,enc_avif,quality_auto/7ceffa_b2af1100d668434084c6500587fedaa8~mv2.png',
							'https://static.wixstatic.com/media/7ceffa_ffc78fe9c19344039bf00e39bb3fab70~mv2.png/v1/fit/w_430,h_664,q_90,enc_avif,quality_auto/7ceffa_ffc78fe9c19344039bf00e39bb3fab70~mv2.png',
							'https://static.wixstatic.com/media/7ceffa_7004d9ac4d4e4c46b4a0828969889f5b~mv2.png/v1/fit/w_430,h_664,q_90,enc_avif,quality_auto/7ceffa_7004d9ac4d4e4c46b4a0828969889f5b~mv2.png',
							'https://static.wixstatic.com/media/7ceffa_e148a43b7aee4ff195ab787620f1dffb~mv2.png/v1/fit/w_430,h_664,q_90,enc_avif,quality_auto/7ceffa_e148a43b7aee4ff195ab787620f1dffb~mv2.png',
							'https://static.wixstatic.com/media/7ceffa_714f5c2553b941deb6f92d205434a321~mv2.png/v1/fit/w_430,h_664,q_90,enc_avif,quality_auto/7ceffa_714f5c2553b941deb6f92d205434a321~mv2.png',
							'https://static.wixstatic.com/media/7ceffa_d8eeb52d7794476eac6f3373f251c7ec~mv2.png/v1/fit/w_430,h_664,q_90,enc_avif,quality_auto/7ceffa_d8eeb52d7794476eac6f3373f251c7ec~mv2.png',
							'https://static.wixstatic.com/media/7ceffa_11fe85005b3741e388bb3302c9bdf28b~mv2.png/v1/fit/w_430,h_664,q_90,enc_avif,quality_auto/7ceffa_11fe85005b3741e388bb3302c9bdf28b~mv2.png',
							'https://static.wixstatic.com/media/7ceffa_c3104068865c44cb80824c799157bfb5~mv2.png/v1/fit/w_430,h_664,q_90,enc_avif,quality_auto/7ceffa_c3104068865c44cb80824c799157bfb5~mv2.png'
						],
						startPosition: index
					});
				}


			},
			bookNow () {
				this.$emit('bookBtnClick');
			}
		},
		mounted () {
		}
	};
</script>

<style scoped lang="less">
@import './kisHome.less';
</style>